import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import ServiceBoxRegular from '../../../Shared/ServiceBox/ServiceBoxRegular/ServiceBoxRegular';
import Config from 'app/Config';

const AllActionsPopup = (props) => {
  return (
    <div className={` ${isMobile ? 'isMobile pr-0 pl-0' : ''} text-center allActionsPopup-popup`}>
      <div className='semiBold main-text d-block w-100'>{props.title}</div>
      <div>
        <div className='w-100 d-flex actions-wrapper'>
          {props.actions.map((action, i) => {
            return (
              <ServiceBoxRegular
                key={i}
                callback={() => props.goToAction(action.actionUrl)}
                isHaveBadge={action.isHaveBadge}
                badgeText={action.badgeText}
                actionName={action.actionName}
                backgroundImage={Config.epiBaseUrl + action.iconUrl}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AllActionsPopup;
